import { IDepositKreditsFormValues } from 'features/Kredits/types'
import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

const messages = defineMessages({
  required: {
    id: 'kredits.multipleActions.field.required',
    defaultMessage: 'This field is required'
  }
})
export const schema = (intl: IntlShape): yup.SchemaOf<IDepositKreditsFormValues> => {
  return yup.object().shape({
    creditType: yup.string().required(intl.formatMessage(messages.required)),
    amount: yup.string().required(intl.formatMessage(messages.required))
  })
}
